import { call, put, takeEvery } from 'redux-saga/effects';
import { apiFetchImpcsWithMrdsDefault, apiFetchImpcList } from '../../api/ImpcAPI';
import {
  fetchImpcsWithMrdsSuccessActionCreator,
  fetchImpcsWithMrdsFailureActionCreator,
  fetchAllImpcsSuccessActionCreator,
  fetchAllImpcsFailureActionCreator,
} from '../actions/ImpcActions';
import { FETCH_IMPC_WITH_MRD_REQUEST } from '../actions/types/ImpcActionTypes';
import { AUTH_LOGIN_SUCCESS } from '../../../redux/actions/types/authActionTypes';
import { GET_MRD_FORM_FIELDS } from '../../../../application/mrd-administration/device-information/redux/actions/types/DeviceInformationActionTypes';

function* fetchDefaultImpcsWithMrds() {
  try {
    const response = yield call(apiFetchImpcsWithMrdsDefault);
    const responseData = response.data;
    yield put(fetchImpcsWithMrdsSuccessActionCreator(responseData));
  } catch (e) {
    yield put(fetchImpcsWithMrdsFailureActionCreator(e));
  }
}

function* getAllImpcsWorker(action) {
  try {
    const response = yield call(apiFetchImpcList, action.payload || {});
    const responseData = response.data;
    yield put(fetchAllImpcsSuccessActionCreator(responseData));
  } catch (e) {
    yield put(fetchAllImpcsFailureActionCreator(e));
  }
}

function* impcWatcher() {
  yield takeEvery(FETCH_IMPC_WITH_MRD_REQUEST, fetchDefaultImpcsWithMrds);
  yield takeEvery(AUTH_LOGIN_SUCCESS, fetchDefaultImpcsWithMrds);
  yield takeEvery(GET_MRD_FORM_FIELDS, getAllImpcsWorker);
}

export default impcWatcher;
export {
  fetchDefaultImpcsWithMrds,
  getAllImpcsWorker,
};
